import http from '@/utils/http';
const base_path = '/v2/tool/convert';

/**
 * 获取转化列表接口
 * @param {Object} params 查询参数
 * @returns {Promise<Object>}
 */
export const getConvertApi = (params) => {
  return http.get({
    url: base_path,
    params,
  });
};
